import Main from "./components/main/Main";
import Sidebar from "./components/sidebar/Sidebar";
const App = () => {
  return (
    <>
      <Sidebar />
      <Main />
    </>
  );
};

export default App;
